import {
  IconStar as StarIconOutline,
  IconStar as StarIconSolid,
} from "@tabler/icons-react";

export function renderAssessmentSettingsLabel() {
  return "Job qualifications";
}

export function renderCustomFieldDefinitionImportanceMustHaveIcon() {
  return <StarIconSolid className="h-4 w-4 text-yellow-500" />;
}

export function renderCustomFieldDefinitionImportanceOther() {
  return <StarIconOutline className="h-4 w-4 text-gray-400" />;
}
